import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AgentTogglePanel from "../components/TogglePanel/AgentTogglePanel";
import { agentsApi } from "../services/agentsApi";
import { AgentTrainingFlow } from "../types/flowTypes";

export default function AgentDetailPage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [agent, setAgent] = useState<any | null>(null);
    const [trainingFlow, setTrainingFlow] = useState<AgentTrainingFlow | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        setLoading(true);

        async function load() {
            console.log('[AgentDetailPage] 🔍 Cargando agente/flow con ID:', id);
            
            // Intentar cargar desde tabla agents primero
            try {
                if (!id) return;
                const agentData = await agentsApi.getAgent(id);
                if (agentData && mounted) {
                    console.log('[AgentDetailPage] ✅ Agente encontrado en tabla agents:', agentData);
                    // Map DB fields to UI fields
                    setAgent({
                        id: agentData.id,
                        name: agentData.nombre,
                        description: agentData.descripcion || undefined,
                        status: (agentData.is_active ? 'active' : 'inactive') as 'active' | 'inactive',
                        shortDescription: agentData.descripcion || undefined,
                        systemPrompt: agentData.instruccion || undefined,
                        active_workflow_id: agentData.active_workflow_id,
                        _dbAgent: agentData, // keep raw DB data
                    });
                    setTrainingFlow(null);
                    setLoading(false);
                    return;
                }
            } catch (err) {
                console.warn('[AgentDetailPage] ⚠️ No se encontró en tabla agents, intentando agent_training_flows:', err);
            }

            // Si no existe en agents, podría ser un flow viejo — no mostrar nada
            console.warn('[AgentDetailPage] ❌ No se encontró agente con ID:', id);
            if (mounted) setLoading(false);
        }

        load();
        return () => { mounted = false; };
    }, [id]);

    if (loading) return <div>Loading...</div>;

    // If no agent or flow found, redirect back to agents list
    if (!agent && !trainingFlow) {
        navigate('/agents');
        return null;
    }


    // Save agent/config changes from AgentConfig
    const handleSaveAgent = async (payload: {
        name?: string;
        shortDescription?: string;
        funnel?: string;
        role?: string;
        objective?: string;
        contraindications?: string;
        notes?: string;
    }) => {
        if (!agent?.id) return;
        try {
            const updates: any = {};
            if (payload.name) updates.nombre = payload.name;
            if (payload.shortDescription) updates.descripcion = payload.shortDescription;
            if (payload.role) updates.rol = payload.role;
            if (payload.objective) updates.objetivo = payload.objective;
            if (payload.contraindications) updates.contraindicacion = payload.contraindications;
            if (payload.notes) updates.notas = payload.notes;

            await agentsApi.updateAgent(agent.id, updates);
            setAgent((prev: any) => prev ? { ...prev, name: payload.name || prev.name, shortDescription: payload.shortDescription || prev.shortDescription } : prev);
        } catch (error) {
            console.error('[AgentDetailPage] Error saving agent:', error);
        }
    };

    return (
        <div className="p-6">
            {/* Show the AgentTogglePanel inline so the header fits the page layout */}
            <AgentTogglePanel
                agent={agent}
                isOpen={true}
                onClose={() => navigate('/agents')}
                trainingFlow={trainingFlow}
                loadingFlow={loading}
                isSavingTraining={false}
                onSaveAgent={handleSaveAgent}
                inline={true}
            />
        </div>
    );
}
